<template>
    <div 
        class="htmlClickImgEnlarge el-tiptap-editor__content" >
        <div 
            class="el-tiptap-editor__content"
            @click="wrapClick($event, content)" 
            v-html="content">
        </div>

        <el-image-viewer
            ref="elImageViewer"
            v-if="showViewer"
            :z-index="20000"
            :on-close="closeViewer"
            :url-list="srcList"
        />
    </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    // 适用于v-html 中的图片点击放大效果
    name: 'HtmlClickImgEnlarge',
    components: {
        ElImageViewer
    },
    props: {
        content: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            showViewer: false,
            srcList: []
        }
    },
    methods: {
        // 关闭大图预览
        closeViewer() {
          this.showViewer = false
        },
        
        // v-html模块点击
        wrapClick(event, item) {
          const target = event.target
          if (target.tagName === 'IMG') {
            // console.log(event.target.src)
            event.preventDefault()
            const content = item
            const imgReg = /<img.*?(?:>|\/>)/gi                   // 匹配图片中的img标签
            const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i            // 匹配图片中的src
            const arr = content.match(imgReg)                   // 筛选出所有的img
            const srcArr = []
            for (let i = 0; i < arr.length; i++) {
              const src = arr[i].match(srcReg)
              // 获取图片地址
              srcArr.push(src[1])
            }
            this.srcList = srcArr

            this.srcList.unshift(event.target.src)
            const set = new Set(this.srcList)
            this.srcList = Array.from(set)
            this.showViewer = true
            this.$nextTick(() => {
                this.slideBanner()
            })
          }
        },
        // 滑动切换
        slideBanner() {
            //选中的轮播图
            var box = document.querySelector('.el-image-viewer__wrapper');
            console.log(box)
            var startPointX = 0
            var stopPointX = 0
            //重置坐标
            var resetPoint = function () {
                startPointX = 0
                stopPointX = 0
            }
            //手指按下
            box.addEventListener("touchstart", function (e) {
                //手指点击位置的X坐标
                startPointX = e.changedTouches[0].pageX
            });
            //手指滑动
            box.addEventListener("touchmove", function (e) {
                //手指滑动后终点位置X的坐标
                stopPointX = e.changedTouches[0].pageX
            });
            //当手指抬起的时候，判断图片滚动离左右的距离
            let that = this
            box.addEventListener("touchend", function (e) {
                if (stopPointX == 0 || startPointX - stopPointX == 0) {
                resetPoint()
                return
                }
                if (startPointX - stopPointX > 0) {
                resetPoint()
                that.$refs.elImageViewer.next()
                return
                }
                if (startPointX - stopPointX < 0) {
                resetPoint()
                that.$refs.elImageViewer.prev()
                return
                }
            });
        },
    
    }
}


</script>

<style lang="scss" scoped>

    .htmlClickImgEnlarge{
        width: 100%;
    }
    .htmlClickImgEnlarge div{
        width: 100%;
    }

</style>
<style lang="scss">
.htmlClickImgEnlarge p{
    // min-height: 30px;
}
</style>